module.exports = __webpack_public_path__ + "img/banner.e3dbf7ef.jpg";